import styled from 'styled-components';

import { XButton } from '@riac/design-system';

export const WishlistItem = styled.div`
  display: flex;
  justify-content: space-between;
  > div {
    display: flex;
    flex-wrap: wrap;
    ${(props) => props.theme.tablet} {
      flex-wrap: nowrap;
    }
  }
  * {
    color: ${(props) => props.theme.black[90]};
  }
  margin-bottom: 25px;

  ${XButton} {
    height: 30px;
    width: 30px;
    flex-shrink: 0;
    align-self: flex-start;
    background: none;
    * {
      color: darkred;
    }
    &:hover {
      background: ${(props) => props.theme.black[10]};
    }
  }
`;

